(() => {
    Metro.i18n.add("es-ES", {
        weekStart: 0,

        january: "Enero",
        february: "Febrero",
        march: "Marzo",
        april: "Abril",
        may: "Mayo",
        june: "Junio",
        july: "Julio",
        august: "Agosto",
        september: "Septiembre",
        october: "Octubre",
        november: "Noviembre",
        december: "Diciembre",

        january_short: "Ene",
        february_short: "Feb",
        march_short: "Mar",
        april_short: "Abr",
        may_short: "May",
        june_short: "Jun",
        july_short: "Jul",
        august_short: "Ago",
        september_short: "Sep",
        october_short: "Oct",
        november_short: "Nov",
        december_short: "Dic",

        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",

        sunday_short: "Dom",
        monday_short: "Lun",
        tuesday_short: "Mar",
        wednesday_short: "Mié",
        thursday_short: "Jue",
        friday_short: "Vie",
        saturday_short: "Sáb",

        sunday_short_2: "D",
        monday_short_2: "L",
        tuesday_short_2: "M",
        wednesday_short_2: "M",
        thursday_short_2: "J",
        friday_short_2: "V",
        saturday_short_2: "S",

        label_ok: "OK",
        label_cancel: "Cancelar",
        label_done: "Listo",
        label_today: "Hoy",
        label_now: "Ahora",
        label_clear: "Limpiar",
        label_help: "Ayuda",
        label_yes: "Sí",
        label_no: "No",
        label_random: "Aleatorio",
        label_save: "Guardar",
        label_reset: "Restablecer",
        label_submit: "Enviar",
        label_add_user_color: "Agregar a la paleta",
        label_send: "Enviar",
        label_accept: "Aceptar",
        label_cookies_title: "Este sitio usa cookies",
        label_cookies_text: "Este sitio utiliza cookies para garantizar que tengas la mejor experiencia.",
        label_choose_file: "Elegir archivo(s)",
        label_drop_file: "Haz clic o suelta archivo(s) aquí",
        label_files_selected: "{n} archivo(s) seleccionado(s)",

        label_days: "días",
        label_hours: "horas",
        label_minutes: "min",
        label_seconds: "seg",
        label_month: "mes",
        label_months: "meses",
        label_day: "día",
        label_year: "año",
        label_years: "años",

        label_rows_count: "Mostrar:",
        label_search: "Buscar:",
        label_table_info: "Mostrando de $1 a $2 de un total de $3 registros",
        label_prev: "Anterior",
        label_next: "Siguiente",
        label_all: "Todos",
        label_inspector: "Inspector",
        label_goto_page: "Ir a la página",
        label_enter_page: "Escribe la página...",
        label_empty: "Nada para mostrar",
        label_user_colors: "Colores del usuario",
        label_tiles: "Cuadrículas",
        label_list: "Lista",
        label_load_more: "Cargar más",
        label_buy: "Comprar",
        label_buy_now: "Comprar ahora",
        label_buy_today: "Comprar hoy",
        label_download: "Descargar",
        label_search_results: "Buscar resultados",
        label_add: "Agregar",
        label_edit: "Editar",
        label_delete: "Eliminar",
        label_new: "Nuevo",
        label_sell: "Vender",
        label_details: "Detalles",
        label_sorting: "Ordenar",

        label_on: "encendido",
        label_off: "apagado",

        label_rename_tab: "Renombrar pestaña",
        label_close_tab: "Cerrar pestaña",
        label_close_other_tabs: "Cerrar otras pestañas",
        label_close_tabs_left: "Cerrar pestañas a la izquierda",
        label_close_tabs_right: "Cerrar pestañas a la derecha",
        label_close_all_tabs: "Cerrar todas las pestañas",
        label_close_inactive_tabs: "Cerrar pestañas inactivas",

        label_clear_input: "Limpiar",
        label_reveal_password: "Mostrar contraseña",
        label_hide_password: "Ocultar contraseña",
        label_generate_random: "Generar valor aleatorio",
        label_search_input: "Buscar por valor",

        label_note: "Nota",
        label_tip: "Consejo",
        label_info: "Información",
        label_warning: "Advertencia",
        label_question: "Pregunta",
        label_error: "Error",
        label_success: "Éxito",
        label_caution: "Precaución",
        label_alert: "Alerta",
        label_bug: "Bug",
        label_fuck: "Falla catastrófica",
        label_important: "Importante",
        label_shit: "Shit",
        label_air: "Air",

        label_select_all: "Select all",
        label_select_more: "Select...",
        label_select: "Select",
        label_filter: "Filter",

        label_collapse: "Collapse",
    });
})();
